<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'orderCancel'+order.id">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :modal="!mobiletype" :visible.sync="dialogFormVisible" width="90%" @close="showForm = false">
      <div :class="{mobile_upload_order:mobiletype}">
        <h3 class="text-center">{{step==1?'取消任务':'退回费用'}}</h3>
        <div v-if="step == 2">
          <ul v-if="predata" class="popover-price">
            <li><span>商品</span><del
                v-if="predata.original_goods_price.value != predata.goods_price.value">{{predata.original_goods_price.currency_symbol}}{{predata.original_goods_price.value}}</del>
              {{predata.goods_price.currency_symbol}}{{predata.goods_price.value}}</li>
            <li><span>消费税</span><del
                v-if="predata.original_tax_price.value != predata.tax_price.value">{{predata.original_tax_price.currency_symbol}}{{predata.original_tax_price.value}}</del>
              {{predata.tax_price.currency_symbol}}{{predata.tax_price.value}}</li>
            <li><span>商家运费</span><del
                v-if="predata.original_transport_price.value != predata.transport_price.value">{{predata.original_transport_price.currency_symbol}}{{predata.original_transport_price.value}}</del>
              {{predata.transport_price.currency_symbol}}{{predata.transport_price.value}}</li>
            <li><span>其他费用</span><del
                v-if="predata.original_other_price.value != predata.other_price.value">{{predata.original_other_price.currency_symbol}}{{predata.original_other_price.value}}</del>
              {{predata.other_price.currency_symbol}}{{predata.other_price.value}}</li>
            <li><span>商家小计</span><del
                v-if="predata.original_subtotal_price.value != predata.subtotal_price.value">{{predata.original_subtotal_price.currency_symbol}}{{predata.original_subtotal_price.value}}</del>
              {{predata.subtotal_price.currency_symbol}}{{predata.subtotal_price.value}}</li>
              <li v-if="predata.discount_price.value!='0.00' || predata.original_discount_price.value!='0.00'">
                <span>下单优惠</span>
                <del v-if="predata.original_discount_price.value != predata.discount_price.value">-{{predata.original_discount_price.currency_symbol}}{{predata.original_discount_price.value}}</del> {{predata.discount_price.currency_symbol}}{{predata.discount_price.value}}
              </li>
              <li v-if="discount_rule.discount_price || order.joyorders_promo_code">
                <div class="promo_code" v-if="order.joyorders_promo_code">{{order.joyorders_promo_code}}</div>
                <div>{{discount_rule.discount_price}}</div>
              </li>
            <hr class="line">
            <li><span>服务费</span><del
                v-if="predata.original_service_price.value != predata.service_price.value">{{predata.original_service_price.currency_symbol}}{{predata.original_service_price.value}}</del>
              {{predata.service_price.currency_symbol}}{{predata.service_price.value}}</li>
            <hr class="line">
            <li v-if="discount_rule.buyer_service_fee">
              <div class="promo_code" v-if="order.joyorders_promo_code">{{order.joyorders_promo_code}}</div>
              <div>{{discount_rule.buyer_service_fee}}</div>
            </li>
            <li><span>国际运费</span><del
                v-if="predata.international_transport_price.value != predata.original_international_transport_price.value">{{predata.original_international_transport_price.currency_symbol}}{{predata.original_international_transport_price.value}}</del>
              {{international_transport_price_display()}}
            </li>
            <li><span>实时汇率</span>{{predata.rate}}</li>
            <li><span>总计</span><del
                v-if="predata.original_total_price.value != predata.total_price.value">{{predata.original_total_price.currency_symbol}}{{predata.original_total_price.value}}</del>
              {{predata.total_price.currency_symbol}}{{predata.total_price.value}}</li>
            <li><span>{{predata.payment_status}}</span>
              {{predata.payment_price.currency_symbol}}{{predata.payment_price.value}}
            </li>
            <li v-if="predata.paying_amount.value!='0.00'"><span>支付中</span>
              {{predata.paying_amount.currency_symbol}}{{predata.paying_amount.value}}
            </li>
            <li v-if="predata.paying_amount.value!='0.00'"><span>退款中</span>
              {{predata.refunding_amount.currency_symbol}}{{predata.refunding_amount.value}}
            </li>
          </ul>
          <div class="fee_row">
            <el-button class="block" :type="'primary'"  @click="submit()"  :loading="loading">确定</el-button>
          </div>
        </div>
        <div v-if="step == 1">
          <el-row class="select-address">
            <el-col :span="24" class="tip">
              选择取消理由
            </el-col>
          </el-row>
          <el-form>
            <el-row>
              <el-col :span="24" v-for="(res,index) in ressons" :key="index">
                <el-form-item style="margin-bottom: 0!important;">
                  <el-radio v-model="reason" :label="res">{{res}}</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <el-button :loading="isStartCaculating" style="margin: 20px 0 20px;" class="block" :type="'primary'" @click="next">{{isStartCaculating?'计算费用中，请等待...':'确定'}}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../services/api.js'
import {API_HOST} from '../../../services/constant.js'

export default {
  name: 'AddAddress',
  props: ['order', 'isSingle','mobiletype'],
  components: {
  },
  computed: {
  },
  created () {
    if (this.isSingle) {
      this.reason='商家缺货'
      this.ressons = [
        '商家缺货',
        '优惠过期',
        '买单人不想买了',
        '其他原因'
      ]
    }
    this.status=this.order.status
  },
  mounted(){
    ;
  },
  data () {
    return {
      discount_rule:{},
      isStartCaculating:false,
      API_HOST: API_HOST,
      reason: '订单信息有误',
      ressons: [
        '订单信息有误',
        '修改下单条件',
        '商家缺货',
        '优惠过期',
        '不想买了',
        '其他原因'
      ],
      dialogFormVisible: false,
      loading: false,
      status: '',//订单状态
      ids: '',//取消任务包含的商品
      step:1,
      predata:null,
      fee_info:[
        {name:'商品金额',editMode:false,fee:0,fieldName:'goods_price',canEdit:false},
        {name:'消费税',editMode:false,fee:0,fieldName:'tax_price',canEdit:false},
        {name:'商家运费',editMode:false,fee:0,fieldName:'transport_price',canEdit:true},
        {name:'其他费用',editMode:false,fee:0,fieldName:'other_price',canEdit:true},
        {name:'汇率',editMode:false,fee:0,fieldName:'rate',canEdit:false},
        {name:'商家小计',editMode:false,fee:0,fieldName:'subtotal_price',canEdit:false},
        {name:'服务费',editMode:false,fee:0,fieldName:'service_amount',canEdit:false},
        {name:'国际运费',editMode:false,fee:0,fieldName:'international_transport_price',canEdit:true},
        {name:'待退回',editMode:false,fee:0,fieldName:'total_price',canEdit:false},
      ],
      flexFeeRate:0,
      fixedFee:0
    }
  },
  methods: {
    next(){
      this.getpredata()
    },
    international_transport_price_display(){
      //consol.log('')
        let t=this.predata.international_transport_price.currency_symbol+this.predata.international_transport_price.value
        switch(this.predata.international_transport_price.charge_type){
          case "1":
          case "2":
            return this.predata.international_transport_price.charge_type_message+t;
          default:
            return t
        }
    },
    gotoFee(){
      this.getMerchant();
    },
    getMerchant() {
      api.getMerchantDetail(this, { id: this.order.business_id }).then((res) => {
        this.step=2;
        this.fee_info[0].fee=this.order.price_info.goods_price;
        let tax_amount_percent=(this.order.business_id === '4474' ? 0.05 : 0);
        this.fee_info[1].fee=(+this.fee_info[0].fee)*tax_amount_percent;
        let theMerchant = res.body.result;
        let flexFeeRate = this.order.service_type == 1 ? theMerchant.single_service_rate : theMerchant.buyer_service_rate
        this.flexFeeRate = +flexFeeRate.substr(0, flexFeeRate.length - 1)
        this.fixedFee = this.order.service_type == 1 ? theMerchant.single_fixed_amount : theMerchant.buyer_fixed_amount
        this.fee_info[6].fee = ((+this.fee_info[0].fee) + (+this.fee_info[1].fee)) * this.flexFeeRate / 100 + (+this.fixedFee)
        let tmp=((+this.fee_info[0].fee) + (+this.fee_info[1].fee) + (+this.fee_info[2].fee)+(+this.fee_info[3].fee))
        this.fee_info[5].fee = this.$decimalFormat(tmp,2)
        let tmp2=((+this.fee_info[5].fee) + (+this.fee_info[6].fee)+((+this.fee_info[7].fee)))
        this.fee_info[8].fee = this.$decimalFormat(tmp2,2)
      })
    },
    show () {
      this.step=1;
      this.dialogFormVisible = true
    },
    getpredata() {
      this.discount_rule={}
      this.isStartCaculating=true;
        let url=API_HOST+"/api/order.php?api=get_price_info&type=2";
        this.$http.post(url,{order_id:this.order.id}).then(data =>{ 
          //this.step=1;
          this.predata=data.body.result;
          this.isStartCaculating=false;
          this.step=2;
          for(let p in this.predata.discount_rule_info){
            if(!this.predata.discount_rule_info[p].error){
              if(this.predata.discount_rule_info[p].discount_rule)
                this.discount_rule[p]=this.predata.discount_rule_info[p].discount_rule.display_name
            }
          }  
        })
    },
    toEditMode(fee){
      if(fee.canEdit){
        fee.editMode=true;
      }
    },
    closeEditMode(fee){
      let t=((+this.fee_info[0].fee) + (+this.fee_info[1].fee) + (+this.fee_info[2].fee)+(+this.fee_info[3].fee))
      this.fee_info[5].fee = this.$decimalFormat(t,2)
      let t2=((+this.fee_info[5].fee) + (+this.fee_info[6].fee)+((+this.fee_info[7].fee)))
      this.fee_info[8].fee = this.$decimalFormat(t2,2)
      fee.editMode=false;
    },
    async submit () {
      //this.getrefund()
      let res = await api.post(this, {
        path: 'order.php',
        api: 'cancel_order',
        data: {
          order_id: this.order.id,
          role:this.isSingle?'buyer':'customer',
          reason: this.reason,
          update_time: this.order.update_time
        },
        loading: 'loading'
      })
      res = res.body
      if (res.status == 'ok') {
        let data = {
          status: this.status,
          operationType: '取消任务成功',
          type: '任务',
          name: this.isSingle ? '付款人': '付款人',
          refund: this.predata.payment_price.value
        }
        this.$emit('complete', data)

        this.dialogFormVisible = false
        this.order.update_time = res.result.update_time
        for(let key in this.order.groupOrderLines){
              this.order.groupOrderLines[key].forEach((g)=>{
                g.status='0'
              })
        } 
        this.order.status = '30'
        this.$emit('refresh', res.result.price_info);
      }
      this.ids = []
      console.log(this.ids)
    },
    async getrefund (){
      this.ids = []
      _.each(this.order.goods_list, line => {
        if (line.status != 3) {
          this.ids.push(line.id)
        }
      })
      console.log(this.ids)
      let amount = await api.post(this, {
        path: 'order.php',
        api: 'amount_when_cancel_goods_by_number',
        data: {
          order_id: this.order.id,
          good_info_list: this.ids
        },
        loading: 'loading'
      })
      amount = amount.body
      if (amount.status == 'ok') {
        let data = {
          status: this.status,
          operationType: '取消任务成功',
          type: '任务',
          name: this.isSingle ? '付款人': '付款人',
          refund: amount.result
        }
        this.$emit('complete', data)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .popover-price {
    padding: 13px 13px;
    li {
      clear: both;
      text-align: right;
      color: #333333;
      line-height: 24px;

      span {
        float: left;
        color: #999999;
      }

      del {
        color: #B0B4BF;
      }
    }

    .line {
      float: left;
      width: 100%;
      height: 1px;
      border: 1px dashed #ccc;
    }
  }
  .dialog-form {
    padding-bottom: 40px;
  }
  .tip {
    font-size:16px;
    color:rgba(136,136,136,1);
    line-height:24px;
    margin-bottom: 5px;
  }
  .add-tip {
    font-size:14px;
    color:rgba(102,102,102,1);
    line-height:24px;
    margin-left: 5px;
  }
  .back {
    float: left;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
  }

  .select-address {
    padding-bottom: 7px;
    border-bottom: 1px solid #CDCDCD;
    margin-bottom: 10px;
  }
  .mobile_upload_order {
    padding: 10px;
    text-align: left !important;
  }
  .fee_table{
    width:100%;
    border:none;
  }
  .fee_table td{
    padding:10px 5px;
  }
  .fee_row{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px 0;
  }
  .fee_row label.canEdit{
    cursor: pointer;
  }
  .promo_code{
    border: 1px solid #D9D9D9;
    display: inline-block;
    padding: 0 10px;
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/OrderCancelDialog.vue